<template>
  <el-row>
    <el-col>
      <el-card
        v-loading="isLoading"
        shadow="never"
      >
        <PickupsPickupEventsTable :events="events" />

        <el-pagination
          class="text-center pt-3"
          :current-page.sync="events.page"
          :page-size.sync="events.limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="events.total"
          @size-change="reload"
          @current-change="reload"
        />
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import PickupsPickupEventsTable from '@/components/Application/CustomerService/Pickups/Pickup/Events/Table'

export default {
  components: {
    PickupsPickupEventsTable
  },
  data () {
    return {
      breadcrumb: {
        name: 'History',
        route: { name: 'customerservice-pickups-pickup-history', params: { pickupId: this.$route.params.pickupId } }
      },
      actions: [
        {
          name: 'Refresh',
          icon: ['fal', 'sync'],
          event: this.reload
        }
      ],
      isLoading: false,
      events: []
    }
  },
  mounted () {
    this.load()
  },
  methods: {
    async load () {
      this.isLoading = true

      this.events = await this
        .$sdk
        .pickup_event
        .list(request => {
          request.context = { resource: this.$sdk.pickup.name, identifier: this.$route.params.pickupId }
          request.order = 'created_at:desc'
          request.include = [ 'profile' ]
        })

      this.isLoading = false
    },
    async reload () {
      this.isLoading = true

      await this.events.reload()

      this.isLoading = false
    }
  }
}
</script>
